import React, { ReactElement, ReactNode, InputHTMLAttributes } from "react";
import MaatschappijKeuzelijstPresentation from "./MaatschappijKeuzelijstPresentation";
import { useMaatschappijData, Soort } from "../../hooks/use-maatschappij-data";

export type MaatschappijKeuzelijstProps = {
  name: string;
  soort: Soort;
  appendChildren?: ReactNode;
  readonly?: boolean;
  visible?: boolean;
  fieldSize?: "xl" | "l" | "m" | "s";
  emptyValue?: string;
  addAnders?: boolean;
  inclInactievePartijen?: boolean;
};

const MaatschappijKeuzeLijst = ({
  soort,
  name,
  appendChildren,
  readonly,
  fieldSize,
  emptyValue,
  onChange,
  addAnders = false,
  inclInactievePartijen = false
}: MaatschappijKeuzelijstProps & InputHTMLAttributes<HTMLSelectElement>): ReactElement | null => {
  const { error, maatschappijen } = useMaatschappijData(soort, inclInactievePartijen);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <MaatschappijKeuzelijstPresentation
      name={name}
      maatschappijen={maatschappijen}
      appendChildren={appendChildren}
      readonly={readonly}
      fieldSize={fieldSize}
      emptyValue={emptyValue}
      onChange={onChange}
      addAnders={addAnders}
    />
  );
};

MaatschappijKeuzeLijst.displayName = "MaatschappijKeuzelijst";

export default MaatschappijKeuzeLijst;
